import { concatClassnames } from "shared/utils/concatClassnames";
import { Link } from "react-router-dom";

interface CustomLinkProps {
  children: any;
  bold?: boolean;
  className?: string;
  opacityTransition?: boolean;
  to: string;
}
const CustomLink = ({
  children,
  bold = true,
  className,
  opacityTransition = true,
  to,
}: CustomLinkProps) => {
  return (
    <Link
      to={to}
      className={concatClassnames(
        "gg-relative",
        bold && "gg-font-bold",
        opacityTransition &&
          "gg-opacity-80 gg-transition-opacity gg-duration-300 hover:gg-opacity-100",
        opacityTransition &&
          "after:gg-block after:gg-w-full after:gg-h-0.5 after:gg-bg-black after:gg-absolute",
        opacityTransition &&
          "after:-gg-bottom-0.5 after:gg-opacity-0 after:gg-transition-opacity hover:after:gg-opacity-100 after:gg-duration-300",
        opacityTransition && "after:gg-left-0 after:gg-right-0",
        className
      )}
    >
      {children}
    </Link>
  );
};
export default CustomLink;
